(async () => {

  if (!customElements.get('product-card-swiper')) {

    const { default: Swiper, Navigation } = await import("swiper");

    Swiper.use([
      Navigation
    ]);

    class ProductCardSwiper extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-product-card]');

        this.swiperOptions = {
          watchOverflow: true,
          preventClicks: true,
          loop: false,
          autoplay: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          slidesPerView: 1,
          direction: 'horizontal'
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      }

    }

    window.ProductCardSwiper = ProductCardSwiper;
    customElements.define('product-card-swiper', ProductCardSwiper);

  }

  if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {
      constructor() {
        super();

        // Loader for variants on the collection (when the product card is using the parameter with_js = true)
        this.productGroupLoader = this.querySelector('[data-product-group-loader]');

        // If the element is there load the buttons first
        if(this.productGroupLoader) {
          this.fetchProductGroup();
        }
      }

      /**
      * fetchProductGroup
      */
      async fetchProductGroup() {
        const productGroupTag = this.productGroupLoader.dataset.productGroupTag.replaceAll(': ', ':');
        const productGroupCollection = this.productGroupLoader.dataset.productGroupCollection;
        const html = await fetch(`/collections/${productGroupCollection}/${productGroupTag}?section_id=product-tagged-group`)
          .then(response => {
            if(response.ok) {
              return response.text()
            } else {
              throw new Error('Something went wrong!');
            }
          })
          .then(data => {
            return data;
          })
          .catch((error) => {
            console.log(error);
          });

        if(html) {
          // Parse from string
          const productGroup = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-product-tagged-group');
          // Add html to parent
          this.productGroupLoader.appendChild(productGroup);
        }
      }
    }

    window.ProductCard = ProductCard;
    customElements.define('product-card', ProductCard);
  }

})();
